export default "__VITE_ASSET__BCYXMruc__"